// extracted by mini-css-extract-plugin
export default {"actions":"players_actions__8h7bQ"};